import immutableUpdate from 'immutable-update'
/*
{
  games: {
    "gameid": {
      game: {}
    }
  }
}
*/
const initialState = null

const prepareGame = game => {

  return {
    ...game,
    events: game.events?.map(event => {
      return {
        ...event,
        data: event.data ? JSON.parse(event.data) : {},
        rankings: event.rankings.reduce((list, ranking) => {
          list[ranking.rankingId] = ranking
          return list
        }, {})
      }
    }),
    kpis: game.kpis?.reduce((list, kpi) => {
      list[kpi.kpiId] = kpi
      return list
    }, {}),
    player: { ...game.user?.players[0] },
    loaded: game.events !== undefined || game.kpis !== undefined
  }
}

const reducers = {

  RESET: (stage) => {
    return { ...initialState }
  },

  HYDRATE_GAMES: (state, { payload }) => {

    const { games, reset } = payload

    const newgames = games.reduce((list, game) => {

      if (!list[game.gameId]) {

        list[game.gameId] = {
          game: prepareGame(game)
        }
      }

      return list;

    }, reset ? {} : { ...state })

    return newgames
  },

  HYDRATE_GAME: (state, { payload }) => {

    const { gameId, game } = payload
    return {
      ...state,
      [gameId]: prepareGame(game)
    }
  },

  HYDRATE_ALLEVENTS: (state, { payload }) => {

    const { gameId, events } = payload
    return immutableUpdate(
      state,
      {
        [gameId]: {
          allevents: events
        }
      }
    )
  },

  HYDRATE_GAME_USERS: (state, { payload }) => {

    const {gameId, users} = payload
    const newstate = immutableUpdate(
      state,
      {
        [gameId]: {
          gameusersloaded: true,
          users: users.reduce((list, user) => {
            list[user.userId] = list[user.userId] || {} 
            list[user.userId] = { ...list[user.userId], ...user }
            return list
          }, {})
        }
      }
    )

    return newstate
  },

  HYDRATE_WP_USERS: (state, { payload }) => {

    const {gameId, users} = payload
    const newstate = immutableUpdate(
      state,
      {
        [gameId]: {
          wpusersloaded: true,
          users: users.reduce((list, user) => {
            list[user.id] = list[user.id] || {} 
            list[user.id] = { ...list[user.id], ...user }
            return list
          }, {})
        }
      }
    )

    return newstate
  },

  HYDRATE_GAME_NEWS: (state, {payload}) => {

    const {gameId, news} = payload

    return {
      ...state,
      [gameId]: {
        ...state[gameId],
        news: news.sort((a, b) => {
          if (a.post_date < b.post_date) return 1
          if (a.post_date > b.post_date) return -1
          return 0
        })
      }
    }
  },

  UPDATE_USER_DATA: (state, { payload }) => {

    const data = JSON.parse(payload.data)

    return Object.keys(state).reduce((newState, key) => {

      newState[key] = { 
        ...state[key],
        user: {
          ...state[key].user,
          userData: data
        }
      }
      return newState
    }, {})
  }
}

export default (state = initialState, action) => reducers[action.type] ?
  reducers[action.type](state, action)
  :
  state
